import type { DynamicClient } from '../../../client/types';
import { assertDefined } from '../../../utils/assertDefined';
import { p256Sign } from '../../../utils/p256Sign';
import { getSessionKeys } from '../getSessionKeys';

type GenerateSessionSignatureParams = {
  sessionId: string;
};

export const generateSessionSignature = async (
  { sessionId }: GenerateSessionSignatureParams,
  client: DynamicClient
) => {
  const sessionKeys = getSessionKeys(client);
  assertDefined(sessionKeys, 'Session keys not found');

  const { privateKeyJwk } = sessionKeys;

  const signature = await p256Sign({
    message: sessionId,
    privateKeyJwk,
  });

  return { signature };
};
